import "../App.css";
import Button from "@material-ui/core/Button";
import React, { Component } from "react";
import { getEventsData ,getEventsByTeam } from "../services/userServices";
import { trackPromise } from "react-promise-tracker";
import TopBar from "../components/TopBar";
import { PropTypes } from "prop-types";
import { withStyles } from "@material-ui/core";
import CardComponent from "../components/CardComponent";

const styles = theme => ({
  root: {
    // display: "flex",
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  }
});

class EventScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id:'',
      slideCards: false,
      cardStyles: false,

      trash: false,
      teamName:'',
      fetchEvent: []
    };

    const urlParams = new URLSearchParams(window.location.search);
    const _id = urlParams.get('id');
    const _team =  urlParams.get('team');

    console.log("id",_id);

    this.state.id=_id;
    this.state.team=_team;
    this.handleTrash = this.handleTrash.bind(this);

    // this.handleNavigation = this.handleNavigation.bind(this);
  }
  GetFormattedDate(date) {
    var todayTime = new Date(date);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    var month = todayTime.getMonth();
    var day = todayTime.getDate();
    var year = todayTime.getFullYear();
    return monthNames[month] + "    " + day + " , " + year;
  }
  getFormattedTime(mytime) {
    var evt = new Date(mytime);
    var hours = evt.getHours();
    var minutes = evt.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + ampm;
  }
  componentDidMount() {
    console.log("api call id",this.state.id);
    trackPromise(
      getEventsByTeam(this.state.id).then(response => {
        console.log("response", response);
        response = response.sort(function(a, b) {
          // return new Date(b.eventTime) - new Date(a.eventTime);
          return new Date(b.eventTime, b.endTime) - new Date(a.eventTime);
        });
        this.setState({
          fetchEvent: response.reverse()
        });
        console.log("fetchEvent", this.state.fetchEvent);
      })
    ).catch(error => {
      console.log(error);
    });
  }

  componentWillMount = () => {
    // askForPermissioToReceiveNotifications();
  };
  slideCards = () => {
    try {
      this.setState({ slideCards: !this.state.slideCards });
    } catch (err) {
      console.log("error at slideCards in dashBoard");
    }
  };
  /**
   * @description:it handles the cards style
   */
  handleCardStyle = () => {
    try {
      this.setState({ cardStyles: !this.state.cardStyles });
    } catch (err) {
      console.log("error at handleCardStyle in dashBoard");
    }
  };

  async handleTrash(value) {
    // console.log("+++++++++++++++++++++++++++++++++++++",trash);
    console.log("trash", value);
    await this.setState({
      trash: !value
    });
    // isTrashed(this.props.navigation.state.params.Display, this.props.navigation.state.params.notekey)
  }

  render() {
    var arr = [];
    var key;
    var data;

    arr = Object.keys(this.state.fetchEvent).map(notes => {
      key = notes;
      this.state.fetchEvent[key].eventDate = this.GetFormattedDate(
        this.state.fetchEvent[key].eventDate
      );
      this.state.fetchEvent[key].eventTime = this.getFormattedTime(
        this.state.fetchEvent[key].eventTime
      );
      this.state.fetchEvent[key].endTime = this.getFormattedTime(
        this.state.fetchEvent[key].endTime
      );

      data = this.state.fetchEvent[key];
      //teamName=this.state.teamName;
      return (
        //   <CardComponent Display={data}
        //     notekey={key}
        //     view={this.state.click}
        //     navigation={this.props.navigation} />

        <CardComponent
          Display={data}
          noteKey={key}
          view={this.state.click}
          // navigation={this.props.navigation}
        />
      );
    });

    const { classes } = this.props;
    const slidingCards = this.state.slideCards ? "afterSlide" : "beforeSlide";
    const urlParams = new URLSearchParams(window.location.search);
    const team = urlParams.get('team');
    const _id = urlParams.get('id');

    return (
      <div className={classes.root}>
        <div className={slidingCards} id={slidingCards}>
          <div>
            <TopBar
              slideCards={this.slideCards}
              props={this.props}
              notePropsToApp={this.handleCardStyle}
              handleNavigation={this.handleNavigation}
            />
          </div>
        </div>

        {/* 
            <div style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }}>
            {arr}
          </div> */}

        <div className="editpage">
          <div className="two-content" > 
          <div className="setMargin">
            
            {/* <a className="navigation-link" href="/dataGenerate"> */}
              <div
                style={{
                  fontSize: "18px",
                  color: "black",
                  // backgroundColor: "#FFFFFF",
                  // border: "1px solid #422963"
                }}
                //id="LinkButton"
                //title="Click to Create Event"
                // onClick={this.registerclick}
              >
               {team}
              </div>
            {/* </a> */}
          </div>
          <div className="setMargin">
            
            <a className="navigation-link" href={`/eventDataGenerate?team=${team}&id=${_id}`}>
              <Button
                style={{
                  fontSize: "18px",
                  color: "white",
                  backgroundColor: "#422963",
                  border: "1px solid #422963",
                  marginRight: "8rem"
                }}
                id="LinkButton"
                title="Click to Create Event"
                // onClick={this.registerclick}
              >
                Create Event
              </Button>
            </a>
          </div>
          </div>
          

          <div style={{ flexDirection: "row", display: "flexWrap" }}>{arr}</div>
        </div>
      </div>
    );
  }
}

EventScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(EventScreen);
